const TOKEN_KEY = 'sublims_token';
const USER_KEY  = 'sublims_user';

export const saveAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => {
  try { const u = localStorage.getItem(USER_KEY); return u ? JSON.parse(u) : null; }
  catch { return null; }
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};
export const isAuthenticated = () => !!getToken();
